import axios from "axios";

const rootUrl = process.env.REACT_APP_API_ROOT_URL;
const otpUrl = rootUrl + "/user/reset-password";
const updatePassUrl = rootUrl + "/user/reset-password";

export const reqPasswordOtp = email => {
	return new Promise(async (resolve, reject) => {
		try {
			const { data } = await axios.post(otpUrl, { email });
			resolve(data);
		} catch (error) {
			reject(error);
		}
	});
};

export const updateUserPassword = passObj => {
	return new Promise(async (resolve, reject) => {
		try {
			const { data } = await axios.patch(updatePassUrl, passObj);
			resolve(data);
		} catch (error) {
			reject(error);
		}
	});
};
